import React from 'react';
import { Grid } from '@mui/material';
import { GridItemsGroupProps, BreakpointColumns } from './GridItemsGroup.types';
import { Breakpoint } from '@mui/material';

const GridItemsGroup: React.FC<GridItemsGroupProps> = ({
  columns,
  spacing = 0,
  children,
}) => {
  const items = Array.isArray(children) ? children : [children];
  const count = items.length;

  const spans = (Object.entries(columns) as [Breakpoint, number][]).reduce(
    (acc, [bp, total]) => {
      const base = Math.floor(total / count);
      const rem = total % count;
      acc[bp] = { base, rem };
      return acc;
    },
    {} as Record<Breakpoint, { base: number; rem: number }>
  );

  return (
    <Grid item {...columns}>
      <Grid
        container
        spacing={spacing}
        columns={columns}
        width="100%"
        alignItems="center"
      >
        {items.map((child, i) => {
          const childCols = (Object.keys(spans) as Breakpoint[]).reduce(
            (obj, bp) => {
              const { base, rem } = spans[bp];
              obj[bp] = base + (i < rem ? 1 : 0);
              return obj;
            },
            {} as BreakpointColumns
          );

          if (typeof child === 'function') {
            const childFn = child as (
              columns: BreakpointColumns
            ) => React.ReactNode;
            return (
              <React.Fragment key={i}>{childFn(childCols)}</React.Fragment>
            );
          }
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              key: child.key ?? i,
            });
          }
          return null;
        })}
      </Grid>
    </Grid>
  );
};

export default GridItemsGroup;
